<template>
    <div style="line-height: 1.7em">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div v-if="istemplateApplicable">
            <span v-html="rawhtmlcode"></span>
        </div>
        <div v-else-if="istemplateApplicable === false" class="row mt-10" style="justify-content:center">
            <span class="grey--text">
                DOCUMENT TEMPLATE OR LINKING IS MISSING...
            </span>
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    // props: {
    //     org: Number,
    // },
    data() {
        return {
            default_value: [],
            dialog_marks: false,
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            semester_list: null,
            sem: null,
            fetch_loader: false,
            show: false,
            course_list: [],
            stud_list: [],
            awspath: "",
            registration_no: null,
            standard: null,
            div: null,
            ay: null,
            name: null,
            dob: null,
            roll_no: null,
            mobile_no: null,
            address: null,
            mother_name: null,
            photo: null,
            reg_no: null,
            gr_no: null,
            father_full_name: null,
            leraner_marksheet: [],
            semester: null,
            colspan: null,
            overall_grade: null,
            remark: [],
            org_basic_data: [],
            sem1: null,
            sem2: null,
            mother_contact: null,
            father_contact: null,
            allowedStandards: ["I", "II", "III", "IV", "V"],
            rawhtmlcode: [],
            istemplateApplicable: null,
            std: null,
            div: null,
            viewType: null,
            resultType: null,
            status: '0',
            sem_name: null,
            asd: null,
            reg_no: null,
        };
    },
    computed: {
        attendanceColspan() {
            return Object.keys(this.leraner_marksheet.attendance_data || {}).length + 3;
        },
    },
    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            this.overlay = true;
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data,
                sem: this.sem,
                org: this.org,
                viewType: this.viewType,
                resultType: this.resultType,
            };
            console.log("data:", data);
            axios
                .post("/Examination/getAnnualStudentReportTemplate", data)
                .then((res) => {
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                        this.overlay = false;
                        return;
                    }
                    if (res.data.flag == "YES") {
                        this.standard = res.data.standard;
                        this.div = res.data.div;
                        this.ay = res.data.ay;
                        this.name = res.data.name;
                        this.dob = res.data.dob;
                        this.roll_no = res.data.roll_no;
                        this.mobile_no = res.data.mobile_no;
                        this.address = res.data.address;
                        this.mother_name = res.data.mother_name;
                        this.photo = res.data.photo;
                        this.reg_no = res.data.reg_no;
                        this.gr_no = res.data.gr_no;
                        this.father_full_name = res.data.father_full_name;
                        this.leraner_marksheet = res.data.leraner_marksheet;
                        // console.log(this.leraner_marksheet)
                        this.semester = res.data.semester;
                        this.default_value = res.data.default_value;
                        this.org_basic_data = res.data.org_basic_data;
                        this.mother_contact = res.data.mother_contact;
                        this.father_contact = res.data.father_contact;
                        this.overlay = false;
                        this.rawhtmlcode = res.data.output;
                        this.istemplateApplicable = res.data.istemplateApplicable;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong"); // show snackbar
                        this.overlay = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                })
                .finally(() => { });
        },
        handleBulk() {
            this.overlay = true;

            const payload = {
                ay: this.sel_ay_data,
                sem: this.sem,
                standard: this.std,
                division: this.div,
                org: this.org,
                status: this.status,
                viewType: this.viewType,
                resultType: this.resultType,
            };

            axios.post("/Examination/getAnnualStudentReportTemplateBulk", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.rawhtmlcode = res.data.output;
                        this.istemplateApplicable = res.data.istemplateApplicable;
                        this.overlay = false;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                        this.overlay = false;
                        return;
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    this.overlay = false;
                })
                .finally(() => {
                    // cleanup
                });
        },

        handleBulkSem() {
            this.overlay = true;

            const payload = {
                ay: this.sel_ay_data,
                sem: this.sem,
                standard: this.std,
                division: this.div,
                org: this.org,
                status: this.status,
                viewType: this.viewType,
                resultType: this.resultType,
            };

            axios.post("/Examination/getSemesterStudentReportTemplateBulk", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.rawhtmlcode = res.data.output;
                        this.istemplateApplicable = res.data.istemplateApplicable;
                        this.overlay = false;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                        this.overlay = false;
                        return;
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    this.overlay = false;
                })
                .finally(() => {
                    // cleanup
                });
        },
        generateLearnerExamMarksheet() {
            this.overlay = true;
            const payload = {
                ay: this.sel_ay_data,
                sem: this.sem,
                standard: this.std,
                division: this.div,
                org: this.org,
                status: this.status,
                viewType: this.viewType,
                resultType: this.resultType,
                asd: this.asd,
                reg_no: this.reg_no,
            };

            axios.post("/Examination/generatelearnerexammarksheet", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.rawhtmlcode = res.data.output;
                        this.istemplateApplicable = res.data.istemplateApplicable;
                        this.overlay = false;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                        this.overlay = false;
                        return;
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    this.overlay = false;
                })
                .finally(() => {
                    // cleanup
                });
        },
        generateSem() {
            this.overlay = true;
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data,
                sem: this.sem,
                org: this.org,
                viewType: this.viewType,
                resultType: this.resultType
            };
            console.log("data:", data);
            axios
                .post("/Examination/getSemsterStudentReportTemplate", data)
                .then((res) => {
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                        this.overlay = false;
                        return;
                    }
                    if (res.data.flag == "YES") {
                        this.standard = res.data.standard;
                        this.div = res.data.div;
                        this.ay = res.data.ay;
                        this.name = res.data.name;
                        this.dob = res.data.dob;
                        this.roll_no = res.data.roll_no;
                        this.mobile_no = res.data.mobile_no;
                        this.address = res.data.address;
                        this.mother_name = res.data.mother_name;
                        this.photo = res.data.photo;
                        this.reg_no = res.data.reg_no;
                        this.gr_no = res.data.gr_no;
                        this.father_full_name = res.data.father_full_name;
                        this.leraner_marksheet = res.data.leraner_marksheet;
                        // console.log(this.leraner_marksheet)
                        this.semester = res.data.semester;
                        this.default_value = res.data.default_value;
                        this.org_basic_data = res.data.org_basic_data;
                        this.mother_contact = res.data.mother_contact;
                        this.father_contact = res.data.father_contact;
                        this.overlay = false;
                        this.rawhtmlcode = res.data.output;
                        this.istemplateApplicable = res.data.istemplateApplicable;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong"); // show snackbar
                        this.overlay = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                })
                .finally(() => { });
        },


    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.sel_ay_data = localStorage.getItem("setay");
        this.sem = localStorage.getItem("setsem");
        this.asd = localStorage.getItem("asd");
        this.sem_name = localStorage.getItem("setsem_name");
        this.std = localStorage.getItem("setstd");
        this.div = localStorage.getItem("setdiv");
        this.org = localStorage.getItem("EPS-org-id");
        this.status = localStorage.getItem("status");
        this.viewType = localStorage.getItem("viewType");
        this.resultType = localStorage.getItem("resultType");
        this.reg_no = localStorage.getItem("setreg_no");
        const isExamWise = localStorage.getItem("isExamWise");
        const isBulk = localStorage.getItem("isBulk");
        if (isExamWise === "true") {
            this.generateLearnerExamMarksheet()
        } else {
            if (this.sem_name == 'Annual') {
                if (isBulk === "true") {
                    this.handleBulk();
                } else {
                    this.registration_no = localStorage.getItem("setreg_no");
                    this.onload();
                }
            } else {
                if (isBulk === "true") {
                    this.handleBulkSem();
                } else {
                    this.registration_no = localStorage.getItem("setreg_no");
                    this.generateSem();
                }
            }
        }
    },
};
</script>
<style scoped></style>
